import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { AccordionComponent } from "@core-components/accordion/accordion.component";
import { DialogComponent } from "@core-components/dialog/dialog.component";
import { DropdownComponent } from "@core-components/dropdown/dropdown.component";
import { HubspotFormContainerComponent } from "@core-components/hubspot-form-container/hubspot-form-container.component";
import { InputNumberComponent } from "@core-components/input-number/input-number.component";
import { InputTogglerComponent } from "@core-components/input-toggler/input-toggler.component";
import { LoadingComponent } from "@core-components/loading/loading.component";
import { QuantitySelectorComponent } from "@core-components/quantity-selector/quantity-selector.component";
import { SearchDomainsInputComponent } from "@core-components/search-domains-input/search-domains-input.component";
import { ToasterComponent } from "@core-components/toaster/toaster.component";
import { AppShellNoRenderDirective } from "@core-directives/app-shell-no-render.directive";
import { AppShellRenderDirective } from "@core-directives/app-shell-render.directive";
import { DebounceClickDirective } from "@core-directives/debounce-click.directive";
import { ItemQuantityDirective } from "@core-directives/item-quantity.directive";
import { BlobStoragePipe } from "@core-pipes/blobstorage.pipe";
import { CoveragePipe } from "@core-pipes/coverage.pipe";
import { DirectusPipe } from "@core-pipes/directus.pipe";
import { SafePipe } from "@core-pipes/safe.pipe ";
import { TextColorPipe } from "@core-pipes/textcolor.pipe";
import { TranslatePipe } from "@core-pipes/translate.pipe";
import { TranslateService } from '@shared-services/translate.service';
import { RecaptchaComponent, RecaptchaModule } from "ng-recaptcha";
import { AppRoutingModule } from "../app-routing.module";
import { AppComponent } from "../app.component";
import { OnlyNumbersDirective } from "@core-directives/app-only-numbers.directive";
import { ShowCaseCarouselComponent } from "@core-components/showcase-carousel/showcase-carousel.component";
import { AuthInterceptor } from "./interceptors/auth.interceptor";
import './utils/array.util';
import { ContactAddressPipe } from "@core-pipes/contact-address.pipe";
import { ProcessingComponent } from "@core-components/processing/processing.component";
import { StripProtocolPipe } from "@core-pipes/strip-protocol.pipe";
import { SearchDomainSingleComponent } from "@core-components/search-domain-single/search-domain-single.component";
import { SearchDomainContainerComponent } from "@core-components/search-domain-single/search-domain-container/search-domain-container.component";
import { SearchDomainSingleResultComponent } from "@core-components/search-domain-single/search-domain-container/search-domain-single-result/search-domain-single-result.component";


export function setupTranslateFactory(service: TranslateService): any
{
  return () =>
  {
    service.initService();
  };
}

@NgModule({
  declarations: [
    DialogComponent,
    ToasterComponent,
    TranslatePipe,
    BlobStoragePipe,
    TextColorPipe,
    SafePipe,
    DirectusPipe,
    ContactAddressPipe,

    StripProtocolPipe,
    HubspotFormContainerComponent,
    LoadingComponent,
    ProcessingComponent,
    SearchDomainsInputComponent,
    SearchDomainSingleComponent,
    SearchDomainContainerComponent,
    SearchDomainSingleResultComponent,
    AppShellNoRenderDirective,
    OnlyNumbersDirective,
    AppShellRenderDirective,
    DropdownComponent,
    CoveragePipe,
    AccordionComponent,
    InputNumberComponent,
    InputTogglerComponent,
    ItemQuantityDirective,
    QuantitySelectorComponent,
    DebounceClickDirective,
    ShowCaseCarouselComponent
  ],
  exports: [
    TranslatePipe,
    BlobStoragePipe,
    TextColorPipe,
    DirectusPipe,
    SafePipe,
    ContactAddressPipe,

    StripProtocolPipe,
    DialogComponent,
    ToasterComponent,
    AppShellNoRenderDirective,
    OnlyNumbersDirective,
    AppShellRenderDirective,
    HubspotFormContainerComponent,
    RecaptchaComponent,
    LoadingComponent,
    ProcessingComponent,
    SearchDomainsInputComponent,
    SearchDomainSingleComponent,
    SearchDomainContainerComponent,
    SearchDomainSingleResultComponent,
    DropdownComponent,
    CoveragePipe,
    AccordionComponent,
    InputNumberComponent,
    InputTogglerComponent,
    QuantitySelectorComponent,
    ItemQuantityDirective,
    DebounceClickDirective,
    ShowCaseCarouselComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    RecaptchaModule
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})

export class ShareModule { }
